import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { MaxAppWidth } from '@ally/next-layout'
import Dashboard from './Dashboard'
import NoAccounts from './NoAccounts'
import DashboardError from './DashboardError'

export const Router: React.FC = () => {
  return (
    <MaxAppWidth py="sm">
      <Switch>
        <Route path="/no-accounts" exact>
          <NoAccounts />
        </Route>
        <Route path="/dashboard-error" exact>
          <DashboardError />
        </Route>
        <Route path="/dashboard" exact>
          <Dashboard />
        </Route>
      </Switch>
    </MaxAppWidth>
  )
}

export default Router
